module.exports = __webpack_public_path__ + "img/straw.5aef2f85.svg";